import { Injectable } from '@angular/core';
import { User } from './shared/interfaces/user';
import { UsersService } from './shared/services/users.service';

@Injectable({ providedIn: 'root' })
export class AppStartup {
    public constructor(
        private readonly users: UsersService,
    ) {
        //
    }

    public init(): Promise<User | undefined> {
        return this.users.init();
    }
}
